module.exports = __webpack_public_path__ + "tg.svg?6d8fe20fa59fbdbed45f40187876f212";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/tg.svg
// module id = 1392
// module chunks = 27